import Icon from '../../components/Icon.vue'

Icon.register({"brands/btc":{"width":384,"height":512,"paths":[{"d":"M310.2 242.6C337.9 228.5 355.6 203.2 351.5 161.3 346.1 104 299 84.8 236.6 79.4V0H188.1V77.2C175.5 77.2 162.6 77.5 149.7 77.8V0H101.1V79.4C83.3 79.9 62.5 79.7 3.8 79.4V131.1C42.1 130.4 62.2 127.9 66.8 152.5V369.9C63.9 389.4 48.3 386.6 13.5 386L3.8 443.7C92.2 443.7 101.1 444 101.1 444V512H149.7V444.9C162.9 445.3 175.8 445.3 188.1 445.3V512H236.6V444C317.9 439.6 372.3 419.1 379.5 342.5 385.2 281.1 356.2 253.7 310.2 242.6zM150.6 134.6C178 134.6 263.7 126 263.7 183.1 263.7 237.6 178 231.3 150.6 231.3V134.6zM150.6 386.3V279.8C183.4 279.8 283.7 270.7 283.7 333.1 283.7 393.3 183.4 386.3 150.6 386.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/btc.js
// module id = MeOG
// module chunks = 0